// EDEN · the calm offline state. The shell loads from the service-worker cache; the data
// area says a friendly "You're offline" — never an alarm (Design Brief tone rail). No data
// is cached, so there is nothing stale to show — just a quiet wait for the signal to return.

import { ApiError } from "./api";

/**
 * True when a thrown error is a lost-connection failure (offline), not a real server reply.
 * `fetch()` rejects with a `TypeError` when the network is down; an `ApiError` means the
 * server answered (4xx/5xx) and should surface as itself, not as "offline".
 */
export function isNetworkError(err: unknown): boolean {
  if (err instanceof ApiError) return false;
  return err instanceof TypeError || !navigator.onLine;
}

/** Paint a calm, reassuring offline panel into the app root. */
export function renderOffline(app: HTMLElement): void {
  app.innerHTML = `
    <div class="topbar"><a data-link href="/" class="muted">← Home</a></div>
    <h1>You're offline</h1>
    <p class="empty">EDEN will reconnect on its own when you're back online. Nothing you've saved is lost.</p>
    <button class="btn" id="retry" type="button">Try again</button>`;
  app
    .querySelector<HTMLButtonElement>("#retry")
    ?.addEventListener("click", () => window.dispatchEvent(new Event("eden:rerender")));
}
